var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import styles from '../Viewer.module.scss';
import { getCellTextStyleSettings, renderMultiMatrixCellText } from './utils';
import { useCurrentTheme } from '../../hooks/useCurrentTheme';
import { useSelector } from 'react-redux';
import { selectPreferences, selectView } from '../../Redux/selectors/selectors';
var MultiMatrixCellText = function (_a) {
    var _b;
    var field = _a.field, text = _a.text, played = _a.played, addedData = _a.addedData, rounding = _a.rounding, isStrategy = _a.isStrategy, isOnePlayer = _a.isOnePlayer, isNormalize = _a.isNormalize, useSubstrate = _a.useSubstrate, backgroundColor = _a.backgroundColor, fontSize1player = _a.fontSize1player, fontSize2player = _a.fontSize2player, textcolor1playermatrix = _a.textcolor1playermatrix, textcolor2playermatrix = _a.textcolor2playermatrix, isSmallTrainerMatrix = _a.isSmallTrainerMatrix, multiStackViewMode = _a.multiStackViewMode, selectedCell = _a.selectedCell, cellIndex = _a.cellIndex, isMultiStack = _a.isMultiStack;
    var fontSize = isOnePlayer ? fontSize1player : fontSize2player;
    var mainMatrixValue = useSelector(selectPreferences).viewer.mainMatrixValue;
    var _c = useSelector(selectView), activeQuery = _c.activeQuery, isRequest = _c.isRequest;
    var theme = useCurrentTheme();
    var customBorderColor = theme.matrix.substrate['border color'];
    var isFlop = (_b = activeQuery === null || activeQuery === void 0 ? void 0 : activeQuery.includes('F.')) !== null && _b !== void 0 ? _b : false;
    var settingsWrapper = function (mapper) {
        return getCellTextStyleSettings((isStrategy && !mainMatrixValue) || (isStrategy && !isRequest && !isFlop && mainMatrixValue === 'eqr'), isOnePlayer, mapper, fontSize);
    };
    var color = isOnePlayer ? textcolor1playermatrix : textcolor2playermatrix;
    var lineHeight = isOnePlayer ? settingsWrapper('lineHeight') : '30px';
    var lineHeightPercent = isOnePlayer ? '16px' : '';
    var foreignObjectWidth = isOnePlayer ? '70%' : '90%';
    var foreignObjectX = isOnePlayer ? '15%' : '5%';
    var foreignObjectY = isOnePlayer ? settingsWrapper('substrateY') : '-20%';
    var borderRadius = rounding ? '5px' : '';
    var background = isNormalize && useSubstrate ? backgroundColor : '';
    var getOutlineCell = function () {
        var index = cellIndex;
        if (selectedCell === null || selectedCell === void 0 ? void 0 : selectedCell.includes(index)) {
            return "1px solid ".concat(customBorderColor);
        }
        return '';
    };
    return (_jsx(_Fragment, { children: !isSmallTrainerMatrix && (_jsx("svg", __assign({ version: '1.1', xmlns: 'http://www.w3.org/2000/svg', viewBox: '0 0 100 50', width: '100%', height: '100%', className: styles.textSvgCell, style: { outline: isMultiStack && multiStackViewMode === 'single' ? getOutlineCell() : 'none' } }, { children: _jsxs("foreignObject", __assign({ width: foreignObjectWidth, x: foreignObjectX, y: foreignObjectY, height: isOnePlayer ? settingsWrapper('substrateHeight') : '200%', style: {
                    borderRadius: borderRadius,
                    background: background,
                } }, { children: [_jsx("div", __assign({ style: {
                            color: color,
                            lineHeight: lineHeight,
                            fontSize: settingsWrapper('fontSize'),
                        } }, { children: text })), (!isStrategy ||
                        (isStrategy && !!mainMatrixValue && mainMatrixValue !== 'eqr') ||
                        (isStrategy && !isRequest && isFlop && mainMatrixValue === 'eqr')) && (_jsx("div", __assign({ style: {
                            color: color,
                            lineHeight: lineHeightPercent,
                            fontSize: settingsWrapper('fontSizePercent'),
                        } }, { children: renderMultiMatrixCellText(isStrategy ? mainMatrixValue : field, isStrategy ? addedData : played) })))] })) }))) }));
};
export default MultiMatrixCellText;
